<h2><i [ngClass]="value.icon"></i>{{value.title}}</h2>
<div class="fc-product-details-row" *ngFor="let v of value.messages | elementDisplay">
    <div class="fc-product-details-label">{{ v.label }}<fc-tool-tip [secondary]="v.description"></fc-tool-tip></div>
    <div class="fc-product-details-values">
        <div class="fc-product-details-primary">
            <span [innerHTML]="v.primaryMessage | markedInline"></span>
            <fc-tool-tip [primary]="v.additionalInfo"></fc-tool-tip></div>
        <div class="fc-product-details-secondary" [innerHTML]="v.secondaryMessage"></div>
    </div>
</div>